<section>
  <app-header></app-header>
  <section fxLayout="row" fxLayoutAlign="start start">
    <div fxFlex>
      <router-outlet></router-outlet>
    </div>
  </section>
</section>
